<template>
<div class="content">
  <el-tabs class="tabLv3" type="border-card" v-model="tabName">
    <i class="lt"></i>
    <i class="rt"></i>
    <el-tab-pane name="jsgl">
      <span slot="label">
        <i class="iconfont iconcheck"></i>
        <i class="border"></i> 部门导入工具
      </span>

      <div class="tableWrapper">
        <h1 class="operationTip">操作说明:<br/>
          1,选择一个区域,选择一个部门。<br/>
          2,点击向右的按钮,区域导入进部门列表。<br/>
          3,点击部门右边的叉删除该部门。<br/>
        </h1>


        <div class="el-transfer" style="text-align: left; display: inline-block;">
          <!-- 区域 -->
          <div class="el-transfer-panel" titles="" buttontexts="" filterplaceholder="" leftdefaultchecked="" rightdefaultchecked="" value="1,4" targetorder="original">
            <p class="el-transfer-panel__header">
              <label class="el-checkbox">
                <span class="el-checkbox__input">
                  <span class="el-checkbox__label">
                    区域列表
                  </span>
                </span>
              </label>
            </p>
            <div class="el-transfer-panel__body">
              <div role="group" aria-label="checkbox-group" class="el-checkbox-group el-transfer-panel__list">

                <el-tree :data="areaData" show-checkbox node-key="id" :check-strictly="true" :props="areaDefaultProps" @check="areaCheck" ref="area">
                </el-tree>
              </div>
              <p class="el-transfer-panel__empty" style="display: none;">无匹配数据
              </p>
            </div>
            <p class="curValue">区域选中值: {{areaName}}</p>
          </div>
          <!-- 操作 -->
          <div class="el-transfer__buttons">
            <button type="button" class="el-button el-button--primary el-transfer__button" @click="comfirm">
              <span>
                <i class="el-icon-arrow-right"></i>
              </span>
            </button>
          </div>

          <!-- 部门 -->
          <div class="el-transfer-panel" titles="" buttontexts="" filterplaceholder="" leftdefaultchecked="" rightdefaultchecked="" value="1,4" targetorder="original">
            <p class="el-transfer-panel__header">
              <label class="el-checkbox">
                <span class="el-checkbox__input">
                  <span class="el-checkbox__label">
                    部门列表
                  </span>
                </span>
              </label>
            </p>
            <div class="el-transfer-panel__body">
              <div role="group" aria-label="checkbox-group" class="el-checkbox-group el-transfer-panel__list">

                <el-tree :data="deptData" show-checkbox node-key="id" :props="deptDefaultProps" :check-strictly="true" ref="dept" @check="deptCheck">

                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ data.name }}</span>
                    <span>
                      <i class="el-icon-error" @click="() => remove(node, data)"></i>
                    </span>
                  </span>

                </el-tree>

              </div>
              <p class="el-transfer-panel__empty" style="display: none;">无匹配数据
              </p>
            </div>

            <p class="curValue">部门选中值: {{parentDeptName}}</p>
          </div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import {
  obj2urlsp
} from "utils";
export default {
  name: "",
  data() {
    return {
      tabName: "jsgl",
      areaDefaultProps: {
        label: "name",
        children: "areas",
        disabled: "isSelected",
      },
      areaData: [],
      areaId: "",
      areaName:"",
      deptDefaultProps: {
        label: "name",
        children: "children",
      },
      deptData: [],
      parentDeptId: "",
      parentDeptName: "",
    };
  },
  methods: {
    getArea() {
      //当前人员的单位管理的区域(带选中标识）
      this.$axiosget(
        "operation/deptApi/getSelectedAreaList?userId=".concat(
          this.$store.state.user.id
        )
      ).then((res) => {
        this.areaData = res.data.data;
        //不能选择顶级部门
        this.areaData[0].isSelected = true;
        //区域不能选择安装点
        this.filterType1(this.areaData);
        this.$refs.area.setCheckedKeys([]);
        this.areaId=this.areaName="";
      });
    },
    getDept() {
      this.$axiosget("operation/deptApi/getDeptList").then((res) => {
        this.deptData = res.data.data;
        this.$refs.dept.setCheckedKeys([]);
        this.parentDeptId=this.parentDeptName="";
      });
    },
    filterType1(areas) {
      areas.forEach((area) => {
        if (area.type == 1) {
          this.$set(area, "isSelected", true);
        }
        if (area.areas) {
          this.filterType1(area.areas);
        }
      });
    },
    areaCheck(data) {
      this.$refs.area.setCheckedKeys([data.id]);
      this.areaName = this.$refs.area.getCheckedNodes()[0].name;
      this.areaId = this.$refs.area.getCheckedKeys()[0];
    },
    deptCheck(data) {
      this.$refs.dept.setCheckedKeys([data.id]);
      this.parentDeptName = this.$refs.dept.getCheckedNodes()[0].name;
      this.parentDeptId = this.$refs.dept.getCheckedKeys()[0];
    },
    comfirm() {
      if(!this.areaName){
        this.$message.error("区域未选择");
        return;
      }
      if(!this.parentDeptId){
        this.$message.error("部门未选择");
        return;
      }
      this.$axiospost(
        "operation/deptApi/addDeptByArea",
        obj2urlsp({
          areaId: this.areaId,
          parentDeptId: this.parentDeptId,
        })
      ).then((res) => {
        this.getArea();
        this.getDept();
        this.$message.success("新增成功");
      });
    },
    remove(node, data) {
      this.$confirm(`确定删除${data.name}?`, "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButton",
        cancelButtonClass: "cancelButton",
        type: "warning",
      }).then(() => {
        this.$axiospost(
          "operation/deptApi/deleteDept",
          obj2urlsp({
            id: data.id,
          })
        ).then((res) => {
          this.getArea();
          this.getDept();
          this.$message.success("删除成功");
        });
      });
    },
  },
  mounted() {
    this.getArea();
    this.getDept();
  },
};
</script>

<style lang="less" scoped>
@h:350px;
@ph:40px;
.el-transfer-panel {
  width: 500px;
  height: @h;
  background: transparent;
  border-color: #3d4963;

  * {
    color: #cacaca;
    border-color: #3d4963;
  }

  /deep/ .el-tree {
    .el-tree-node__content:hover,
    .el-tree-node:focus>.el-tree-node__content {
      background: transparent;
    }

    .is-disabled>.el-checkbox__inner {
      display: none;
    }
  }

  /deep/.el-transfer-panel__header {
    background: transparent;

    .el-checkbox .el-checkbox__label {
      color: #cacaca;
    }
  }
}

.el-transfer-panel__list,.el-transfer-panel__body {
  width: 500px;
  height: @h - @ph - 40px;
}

.el-checkbox-group {
  font-size: inherit;
}

.el-tree {
  background: transparent;
}

.operationTip{
  font-size: 12px;
  color: #cacaca;
  margin-bottom: 20px;
}

.curValue{
  font-size: 12px;
  padding-left: 18px;
  height: @ph;
  line-height: @ph;
  box-shadow: 5px -1px 15px 5px rgba(108,134,255,.2);
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/ToolManagement/areaToDept/index.vue